(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SPRING = 'cubic-bezier(.34, 1.56, .64, 1)';
    var EASE   = 'cubic-bezier(.25, 1, .5, 1)';

    function initCard(card) {
      var inner = card.querySelector('[data-inner]');
      var img   = card.querySelector('[data-img]');
      var settleTimer;

      card.addEventListener('mouseenter', function () {
        // Spring-pop overshoot — bouncy ease lifts past 1.06 and lands at 1.04
        card.style.transition = 'transform .4s ' + SPRING;
        card.style.transform = 'scale(1.04)';
        if (img) img.style.transition = 'transform .45s ' + SPRING + ', filter .35s ' + EASE;

        // Once the pop completes, let mousemove drive instant tilt updates
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          if (card.matches(':hover')) {
            card.style.transition = 'transform .12s ease-out';
            if (img) img.style.transition = 'transform .14s ease-out, filter .35s ' + EASE;
          }
        }, 240);
      });

      // 3D tilt toward cursor + image parallax in the OPPOSITE direction
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var cx = rect.left + rect.width  / 2;
        var cy = rect.top  + rect.height / 2;
        var dx = (e.clientX - cx) / (rect.width  / 2);  // -1 to 1
        var dy = (e.clientY - cy) / (rect.height / 2);
        var tiltX = dy * -10; // card rotates toward cursor on X axis (max 10deg)
        var tiltY = dx *  10; // and on Y axis
        // Inner content nudge — gentle parallax with the tilt
        var innerX = dx * 4;
        var innerY = dy * 3;
        // Image parallax OPPOSITE the tilt for layered depth feel
        var imgX = dx * -8;
        var imgY = dy * -6;
        card.style.transform =
          'perspective(900px) rotateX(' + tiltX + 'deg) rotateY(' + tiltY + 'deg) scale(1.04)';
        if (inner) inner.style.transform = 'translateX(' + innerX + 'px) translateY(' + innerY + 'px)';
        if (img)   img.style.transform   = 'scale(1.1) translateX(' + imgX + 'px) translateY(' + imgY + 'px)';
      });

      card.addEventListener('mouseleave', function () {
        clearTimeout(settleTimer);
        card.style.transform = '';
        if (inner) inner.style.transform = '';
        if (img)   img.style.transform   = '';
        card.style.transition = 'transform .5s ' + EASE;
        if (img) img.style.transition = 'transform .5s ' + EASE + ', filter .35s ' + EASE;
        setTimeout(function () {
          card.style.transition = '';
          if (img) img.style.transition = '';
        }, 600);
      });
    }

    function init(root) {
      if (root.dataset.cgInit) return;
      root.dataset.cgInit = '1';

      var grid = root.querySelector('[data-grid]');

      root.querySelectorAll('[data-card]').forEach(initCard);

      // Scroll-triggered wave entrance — fires once when grid enters view.
      if (grid && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              grid.classList.add('is-in-view');
              obs.unobserve(grid);
            }
          });
        }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
        io.observe(grid);
      } else if (grid) {
        grid.classList.add('is-in-view');
      }
    }

    function bootAll() {
      document.querySelectorAll('[data-category-grid]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', bootAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.chInit) return;
      root.dataset.chInit = '1';

      var cursor = root.querySelector('[data-cursor]');
      var parallax = root.querySelector('[data-parallax]');
      var revealSection = root.querySelector('[data-reveal-section]');
      var revealLines = root.querySelectorAll('[data-reveal-line]');

      // Cursor — show only when mouse is inside the section
      function moveCursor(e) {
        if (!cursor) return;
        cursor.style.left = e.clientX + 'px';
        cursor.style.top  = e.clientY + 'px';
      }
      root.addEventListener('mousemove', moveCursor);
      root.addEventListener('mouseenter', function () { cursor && cursor.classList.add('is-visible'); });
      root.addEventListener('mouseleave', function () {
        cursor && cursor.classList.remove('is-visible');
        cursor && cursor.classList.remove('is-big');
      });
      root.querySelectorAll('.ch__btn').forEach(function (el) {
        el.addEventListener('mouseenter', function () { cursor && cursor.classList.add('is-big'); });
        el.addEventListener('mouseleave', function () { cursor && cursor.classList.remove('is-big'); });
      });

      // Parallax hero on scroll + text reveal trigger
      function onScroll() {
        var y = window.scrollY;
        if (parallax) parallax.style.transform = 'translateY(' + (y * 0.6) + 'px)';
        if (revealSection && revealLines.length) {
          var sectionTop = revealSection.getBoundingClientRect().top + y;
          var trigger = y + window.innerHeight * 0.75;
          revealLines.forEach(function (line, i) {
            var lineOffset = sectionTop + i * 120;
            if (trigger > lineOffset) line.classList.add('is-active');
          });
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    function bootAll() {
      document.querySelectorAll('[data-cinematic-hero]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', bootAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
